// extracted by mini-css-extract-plugin
export default {"validatorMessage":"validatorMessage__kKPvsB","tabs":"tabs__bWQxwn","modal":"modal__r8utKj"};